import React from 'react'
import { createTheme } from '@mui/material/styles'
export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#F26419', // Flame Orange
    },
    secondary: {
      main: '#19A6F2', // Teal/Blue
    },
    background: {
      default: '#0E0E11',
      paper: '#1A1A1F',
    },
    text: {
      primary: '#F5F5F7',
      secondary: '#B3B3B6',
    },
    divider: '#2C2C30',
  },
  typography: {
    fontFamily: "'Funnel Sans', sans-serif",
    h1: {
      fontFamily: "'Playfair Display', serif",
      color: '#F5F5F7',
    },
    h2: {
      fontFamily: "'Playfair Display', serif",
      color: '#F5F5F7',
    },
    h3: {
      fontFamily: "'Playfair Display', serif",
      color: '#F5F5F7',
    },
    h4: {
      fontFamily: "'Playfair Display', serif",
      color: '#F5F5F7',
    },
    h5: {
      fontFamily: "'Playfair Display', serif",
      color: '#F5F5F7',
    },
    h6: {
      fontFamily: "'Playfair Display', serif",
      color: '#F5F5F7',
    },
    button: {
      textTransform: 'uppercase',
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1A1F',
          borderRadius: '16px',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            color: '#F5F5F7',
          },
          '& .MuiInputLabel-root': {
            color: '#B3B3B6',
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#2C2C30',
            },
            '&:hover fieldset': {
              borderColor: '#F26419',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#F26419',
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: '#F5F5F7',
        },
      },
    },
  },
})
